import { Amplify } from 'aws-amplify';
import { uploadData } from 'aws-amplify/storage';
import { awsConfig } from '../config/aws-export';

async function S3UploadHookImport(file, key) {
    Amplify.configure(awsConfig);

    try {
        // NOTE: v5's `level: 'public'` (the default) prefixed the key with `public/`, and the
        // literal `../` in the old key walked back out of it — net effect was an object key of
        // `transfer-files/${key}`. v6 has no access-level prefixing, so that path is passed directly.
        // v5's `ACL: 'private'` has no v6 client-side equivalent (Storage no longer sets S3 object
        // ACLs) — access control must come from the bucket policy / backend instead.
        const result = await uploadData({
            path: `transfer-files/${key}`,
            data: file,
            options: {
                contentType: file.type,
            },
        }).result;
        return result.path; // Return the key of the uploaded file
    } catch (error) {
        console.log("error", error);
        throw new Error('S3 upload failed');
    }
}

export default S3UploadHookImport;
